import { useEffect, useState } from 'react'

const getReducedMotionQuery = () =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : null

/** Mirrors `prefers-reduced-motion` without importing framer-motion hooks. */
export const usePrefersReducedMotion = () => {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(() => getReducedMotionQuery()?.matches ?? false)

  useEffect(() => {
    const media = getReducedMotionQuery()
    if (!media) {
      return
    }
    const update = () => setPrefersReducedMotion(media.matches)
    update()
    media.addEventListener('change', update)
    return () => media.removeEventListener('change', update)
  }, [])

  return prefersReducedMotion
}
